import { render } from "./CallAlert.vue?vue&type=template&id=59f39a85"
import script from "./CallAlert.vue?vue&type=script&lang=js"
export * from "./CallAlert.vue?vue&type=script&lang=js"

import "./CallAlert.vue?vue&type=style&index=0&id=59f39a85&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__